export default function v2(root, callback) {
    const captchaV2Fields = root.querySelectorAll('[data-google-recaptcha-v2]');

    if (captchaV2Fields.length) {
        window.googleCaptchaV2Callback = () => {
            captchaV2Fields.forEach((field) => {
                grecaptcha.enterprise.render(field.previousElementSibling, {
                    'sitekey': field.dataset.googleRecaptchaSiteKey,
                    'callback': (token) => { callback(token); },
                    'theme': 'light'
                });
            });
        };

        const googleCaptcha = document.createElement('script');
        googleCaptcha.src = `https://www.google.com/recaptcha/enterprise.js?onload=googleCaptchaV2Callback&render=explicit`;

        document.querySelector('body').appendChild(googleCaptcha);
    }
};
